import {
  productBundleDataIsResolved,
  productIsLazy
} from '@/domain/Product.ts';
import BundleProduct from '../BundleProduct/BundleProduct.tsx';
import { type ResolvedBundleProducts } from '../BundleProductsList/BundleProductsList.tsx';
import styles from './BundledItems.module.scss';

export type BundledItemsProps = {
  headingText?: string;
  errorLoadingProductText: string;
  bundleProducts: ResolvedBundleProducts;
};
export default function BundledItems({
  headingText,
  bundleProducts,
  errorLoadingProductText
}: BundledItemsProps) {
  if (!bundleProducts || bundleProducts.length === 0) {
    return null;
  }
  return (
    <div class={styles.container}>
      {headingText && <h2 class={styles.heading}>{headingText}</h2>}
      <ul class={styles.list}>
        {bundleProducts.map((item) => {
          if (productBundleDataIsResolved(item)) {
            return (
              <BundleProduct
                product={item}
                quantityInBundle={item.quantityInBundle}
                key={item.id}
              />
            );
          }
          if (productIsLazy(item)) {
            return <BundleProduct.Skeleton key={item.id} />;
          }
          return <BundleProduct.Outline label={errorLoadingProductText} />;
        })}
      </ul>
    </div>
  );
}
